import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {

    const draft = localStorage.getItem("draft");

    if (!(draft === null || draft === undefined)) {
      location.href = "/survey";
    }
  }

  startClick() {
    this.router.navigateByUrl('/survey');
  }
}
